import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>1. General Provisions</Summary>
        <Details>
          <Text>
            1.1. These self-service terms of use (hereinafter{" "}
            <strong>Terms</strong>) regulate the use of the Fresh Finance OÜ
            self-service environment (hereinafter <strong>Self-Service</strong>)
            by natural and legal persons who have or have had a financial
            obligation to AS PlusPlus Capital (registry code 11919806, address
            Tartu mnt 83, 10115, hereinafter <strong>PlusPlus Capital</strong>)
            or PlusPlus Baltic OÜ (registry code 12273105, address Tartu mnt 83,
            10115 Tallinn, hereinafter <strong>PlusPlus Baltic;</strong>{" "}
            PlusPlus Capital and PlusPlus Baltic hereinafter together as the{" "}
            <strong>Creditors</strong>) and who are registered in Fresh
            Finance’s systems related to Self-Service (hereinafter the{" "}
            <strong>Client</strong>). Fresh Finance is, among other activities,
            engaged in credit servicing activities on behalf of the Creditors
            within the meaning of the Credit Servicers and Credit Purchasers Act
            (<em>Krediidiostjate- ja inkassode seadus</em>).
          </Text>
          <Text>
            1.2. Self-Service allows the Client to access information related to
            their obligations, perform payments and other transactions provided
            by Fresh Finance.
          </Text>
          <Text>
            1.3. By using Self-Service, the Client confirms that they have read,
            agree to, and commit to complying with these Terms. The Terms are
            binding on the Client.
          </Text>
          <Text>
            1.4. In addition to these Terms, the Client must comply with any
            additional instructions provided by Fresh Finance within
            Self-Service when accessing and using it.
          </Text>
          <Text>
            1.5. Fresh Finance reserves the right to unilaterally modify the
            functionalities of Self-Service, the scope of services and
            operations available through it without notifying the Client.
          </Text>
          <Text>
            1.6. Fresh Finance has the right to amend the Terms at any time by
            notifying the Client via Self-Service or its website (
            <a
              href="https://freshfinance.ee"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.freshfinance.ee
            </a>
            ). Amendments take effect from the date of their publication in
            Self-Service or on the website unless otherwise specified in the
            revised Terms.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>2. Accessing Self-Service and Security</Summary>
        <Details>
          <Text>
            2.1. To use Self-Service, the Client must log in using an ID card,
            Mobile-ID, or Smart-ID solution.
          </Text>
          <Text>
            2.2. Fresh Finance has the right to request additional documents and
            information to verify identity or submitted data and to modify the
            identity verification process used in Self-Service.
          </Text>
          <Text>
            2.3. The Client is responsible for ensuring that they have the
            necessary and appropriate software and hardware to use Self-Service.
            The Client must ensure that their security solutions (including
            antivirus software) meet modern standards and do not block access to
            Self-Service.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>3. Client Rights, Obligations, and Responsibilities</Summary>
        <Details>
          <Text>
            3.1. The Client must not use Self-Service for any illegal activities
            or to commit an offense.
          </Text>
          <Text>
            3.2. The Client must not use Self-Service to monitor its
            availability or functionality for competitive purposes.
          </Text>
          <Text>
            3.3. The Client is responsible for the legal consequences of any
            payments, payment orders, instructions, requests, documents, or
            other information submitted via Self-Service.
          </Text>
          <Text>
            3.4. The Client is prohibited from using software that sends
            automated requests to Self-Service. The use of robots, tracking and
            search devices, data sorters, and other automated data input and
            processing tools is also prohibited.
          </Text>
          <Text>3.5. The Client is required to:</Text>
          <Text>
            3.5.1. keep login credentials and authentication tools (e.g.,
            laptop, mobile phone), including ID cards, passwords, and usernames,
            secure to prevent third-party access.
          </Text>
          <Text>
            3.5.2. maintain confidentiality and not disclose any confidential
            information related to the Client, the Creditors, or Fresh Finance
            to third parties.
          </Text>
          <Text>
            3.5.3. keep their information in Self-Service up to date and correct
            and notify Fresh Finance immediately of any changes.
          </Text>
          <Text>
            3.6. The Client is responsible for all obligations undertaken and
            actions performed via Self-Service, as well as the accuracy of the
            data entered.
          </Text>
          <Text>
            3.7. The Client acknowledges that statements, documents, and actions
            performed via Self-Service are legally binding and have the same
            legal effect as handwritten signed documents. Fresh Finance has the
            right to request digital signing of documents submitted through
            Self-Service.
          </Text>
          <Text>
            3.8. The Client may discontinue using Self-Service at any time by
            notifying Fresh Finance through the contact details provided on{" "}
            <a
              href="https://freshfinance.ee"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.freshfinance.ee
            </a>
            . Fresh Finance will then block the Client's access to Self-Service.
          </Text>
          <Text>
            3.9. The Client can submit questions or feedback about Self-Service
            by sending an email to support@freshfinance.ee.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>4. Fresh Finance Rights and Obligations</Summary>
        <Details>
          <Text>
            4.1. Fresh Finance ensures that the Client can use Self-Service in
            accordance with these Terms.
          </Text>
          <Text>
            4.2. Fresh Finance ensures the confidentiality of Client-related
            information and discloses it to third parties only as outlined in
            the Privacy Notice and applicable laws.
          </Text>
          <Text>
            4.3. Fresh Finance has the right to restrict or deny access to
            Self-Service or refuse transactions if:
            <ul>
              <li>
                4.3.1. Fresh Finance becomes aware of a situation where third
                parties may have gained access to the Client’s authentication
                tools;
              </li>
              <li>4.3.2. an attempt to attack Self-Service is detected;</li>
              <li>4.3.3. Self-Service is used violating applicable laws;</li>
              <li>4.3.4. the Client has violated the Terms;</li>
              <li>
                4.3.5. the Client has failed to fulfill obligations under
                agreements with Fresh Finance or the Creditors and has not
                remedied the violation within the given deadline.
              </li>
            </ul>
          </Text>
          <Text>
            4.4. Fresh Finance has the right to suspend or permanently terminate
            Self-Service at any time, with prior notice to the Client.
          </Text>
          <Text>
            4.5. If Fresh Finance suspects that documents or data submitted via
            Self-Service are false or incorrect, it may require the Client to
            provide additional documentation or information.
          </Text>
          <Text>
            4.6. Fresh Finance is not liable for losses if an unauthorized
            person gains access to Self-Service using the Client’s credentials
            and performs transactions on behalf of the Client.
          </Text>
          <Text>
            4.7. Fresh Finance is not responsible for malfunctions caused by the
            Client’s equipment, email configuration, system overload, or the
            Client's failure to meet technical requirements.
          </Text>
          <Text>
            4.8. Fresh Finance has the right to modify Self-Service functions,
            services, and terms to improve the service.
          </Text>
          <Text>
            4.9. Fresh Finance's contact details and means of communication are
            published on its website. Changes to contact details will not
            require separate notification unless required by law or agreements.
          </Text>
          <Text>
            4.10. Fresh Finance is not liable for disruptions caused by force
            majeure events such as natural disasters, government actions, or
            technical failures.
          </Text>
          <Text>
            4.11. If the Client fails to update their information (as required
            in clause 3.5.3.), Fresh Finance assumes that the previously
            provided information is correct until notified otherwise.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>5. Intellectual Property Protection</Summary>
        <Details>
          <Text>
            5.1. Self-Service is the property of Fresh Finance, and all content,
            including graphics, text, logos, icons, and software, is copyrighted
            and protected by intellectual property laws.
          </Text>
          <Text>
            5.2. Copying, reproducing, transmitting, selling, or otherwise
            misusing Self-Service content for unauthorized purposes (including
            commercial use) is prohibited. Unauthorized use of information,
            agreements, payment plans, or other data from Self-Service is
            strictly forbidden and may result in legal consequences.
          </Text>
          <Text>
            5.3. Trademarks used in Self-Service are owned by Fresh Finance OÜ
            or a company belonging to the same consolidation group and are
            protected under applicable laws. Unauthorized use is prohibited.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>6. Personal Data Processing</Summary>
        <Details>
          <Text>
            6.1. Fresh Finance processes personal data related to Self-Service,
            including data already in Fresh Finance's systems and data entered
            by the Client. Fresh Finance processes personal data in accordance
            with the Privacy Notice.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>7. Final Provisions</Summary>
        <Details>
          <Text>
            7.1. The Terms are governed by the laws of the Republic of Estonia.
          </Text>
          <Text>
            7.2. In the event of a complaint, the Client must submit the
            complaint in writing or in a form that can be reproduced in writing.
            The complaint must refer to the facts and/or documents on the basis
            of which the complaint is made. If the Client refers in the
            complaint to a document which is not freely available to Fresh
            Finance, this document must be attached to the complaint.
          </Text>
          <Text>
            7.3. Fresh Finance will respond to complaints within:
            <ul>
              <li>7.3.1. 15 calendar days if the Client is a consumer;</li>
              <li>7.3.2. 30 calendar days if the Client is a legal person.</li>
            </ul>
          </Text>
          <Text>
            7.4. Disputes will be resolved through negotiations. If negotiations
            fail, disputes will be settled in Harju County Court unless
            otherwise required by law.
          </Text>
          <Text>7.5. These Terms are effective from February 11, 2025.</Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
